import { Component } from 'react';

export default class OraculoErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[OraculoErrorBoundary]', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <p style={{ padding: '2rem', textAlign: 'center', fontFamily: "'DM Sans', sans-serif" }}>
          O oráculo não está disponível agora. Tente novamente mais tarde.
        </p>
      );
    }
    return this.props.children;
  }
}
